// flow weak

// earningGraph:
export {fetchEarningGraphDataIfNeeded} from './earningGraph';
export {fetchStatsWidgetDataIfNeeded} from './statsWidget';
export {fetchStatsWidget2DataIfNeeded} from './statsWidget2';
export {fetchStatsCardDataIfNeeded} from './statsCard';
export {fetchStatsTableDataIfNeeded} from './statsTable';
export {fetchStatsGraphDataIfNeeded} from './statsGraph';
export {fetchScoreCardDataIfNeeded} from './scoreCard';
export {fetchLocationMenuDataIfNeeded,changeLocation} from './locationMenu'

export {loginUser,logoutUser} from './user'

// sideMenu:
export {
  openSideMenu,
  closeSideMenu,
  toggleSideMenu,
  getSideMenuCollpasedStateFromLocalStorage
}                                      from './sideMenu';
// teamMates:
export {fetchTeamMatesDataIfNeeded}    from './teamMates';
// userInfos:
export {fetchUserInfoDataIfNeeded}     from './userInfos';
// views:
export {

  enterPage,
  leavePage,  

  enterSimpleTables,
  leaveSimpleTables,

  enterBasicElements,
  leaveBasicElements,

  enterGeneral,
  leaveGeneral,

  enterPageNotFound,
  leavePageNotFound,

  enterStatsCard,
  leaveStatsCard,

  enterEarningGraph,
  leaveEarningGraph,

  enterNotifications,
  leaveNotifications,

  enterWorkProgress,
  leaveWorkProgress,

  enterTwitterFeed,
  leaveTwitterFeed,

  enterTeamMatesView,
  leaveTeamMatesView,

  enterTodoListView,
  leaveTodoListView,

  enterBreadcrumb,
  leaveBreadcrumb,

  enterStat,
  leaveStat,

  enterBasicProgressBar,
  leaveBasicProgressBar,

  enterTabPanel,
  leaveTabPanel,

  enterStripedProgressBar,
  leaveStripedProgressBar,

  enterAlert,
  leaveAlert,

  enterPagination,
  leavePagination
}                                     from './views';



// WEBPACK FOOTER //
// ./src/app/redux/modules/actions.js